export { default } from './P4Counter';
